import { ref } from 'vue';

export function useDatePicker(initialDate: Date) {
  const currentDate = ref(initialDate);

  const currentMonthYear = () => {
    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      year: 'numeric',
    };

    return currentDate.value.toLocaleDateString('pt-BR', options);
  };

  const calendarDays = () => {
    const year = currentDate.value.getFullYear();
    const month = currentDate.value.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    const daysInMonth = lastDay.getDate();
    const daysFromPrevMonth = firstDay.getDay();

    const prevMonthLastDay = new Date(year, month, 0).getDate();
    const prevMonthDays = Array.from({ length: daysFromPrevMonth }, (_, i) => ({
      date: new Date(year, month - 1, prevMonthLastDay - daysFromPrevMonth + i + 1),
      isCurrentMonth: false,
      isPrevMonth: true,
    }));

    const currentMonthDays = Array.from({ length: daysInMonth }, (_, i) => ({
      date: new Date(year, month, i + 1),
      isCurrentMonth: true,
    }));

    const totalDaysShown = Math.ceil((daysFromPrevMonth + daysInMonth) / 7) * 7;
    const daysFromNextMonth = totalDaysShown - (daysFromPrevMonth + daysInMonth);

    const nextMonthDays = Array.from({ length: daysFromNextMonth }, (_, i) => ({
      date: new Date(year, month + 1, i + 1),
      isCurrentMonth: false,
      isNextMonth: true,
    }));

    return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];
  };

  const goToPrevMonth = () => {
    currentDate.value = new Date(
      currentDate.value.getFullYear(),
      currentDate.value.getMonth() - 1,
      1
    );
  };

  const goToNextMonth = () => {
    currentDate.value = new Date(
      currentDate.value.getFullYear(),
      currentDate.value.getMonth() + 1,
      1
    );
  };

  return {
    currentDate,
    currentMonthYear,
    calendarDays,
    goToPrevMonth,
    goToNextMonth,
  };
}
